<img src="plans/{{ plan() }}.png" [alt]="plan()" [height]="height()" [class]="classes()" />
